import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/about.css';
import '../assets/css/services.css';
import '../assets/css/services-offered.css';
import '../assets/css/style.css';

export default function Transpotation() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Professional Banner Section */}
            <section className="vas-activity-banner">
                <div className="vas-banner-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="vas-banner-content">
                                <div className="vas-breadcrumb mb-3">
                                    <Link to="/" className="breadcrumb-link">Home</Link>
                                    <span className="breadcrumb-separator">›</span>
                                    <span className="breadcrumb-current">Transportation</span>
                                </div>
                                <h1 className="vas-banner-title">Freight And Transportation</h1>
                                <p className="vas-banner-subtitle">
                                    With 30 years of expertise in Dubai's logistics hub, we provide a full spectrum of transportation solutions designed to keep businesses connected and supply chains flowing.
                                </p>
                                <div className="vas-banner-divider"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Freight Services Section */}
            <section className="freight-services-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-lg-10 mx-auto text-center">
                            <h2 className="freight-main-title">Our Transportation Services</h2>
                            <div className="freight-title-divider"></div>
                        </div>
                    </div>

                    {/* Freight Types Cards */}
                    <div className="row g-4 mb-5">
                        {/* Air Freight */}
                        <div className="col-lg-4 col-md-6">
                            <div className="freight-card">
                                <div className="freight-icon-wrapper">
                                    <i className="fas fa-plane"></i>
                                </div>
                                <h3 className="freight-card-title">Air Freight</h3>
                                <p className="freight-card-desc">
                                    Fast, reliable, and secure cargo movement across global destinations.
                                </p>
                            </div>
                        </div>

                        {/* Sea Freight */}
                        <div className="col-lg-4 col-md-6">
                            <div className="freight-card">
                                <div className="freight-icon-wrapper">
                                    <i className="fas fa-ship"></i>
                                </div>
                                <h3 className="freight-card-title">Sea Freight</h3>
                                <p className="freight-card-desc">
                                    Cost-effective shipping with flexible options for full container loads (FCL) and less-than-container loads (LCL).
                                </p>
                            </div>
                        </div>

                        {/* Land Freight */}
                        <div className="col-lg-4 col-md-6">
                            <div className="freight-card">
                                <div className="freight-icon-wrapper">
                                    <i className="fas fa-truck"></i>
                                </div>
                                <h3 className="freight-card-title">Land Freight</h3>
                                <p className="freight-card-desc">
                                    Regional trucking and cross-border transport with optimized routes and schedules.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us Section */}
            <section className="freight-why-choose">
                <div className="container">
                    <div className="row g-4">
                        {/* Feature 1 */}
                        <div className="col-lg-6">
                            <div className="freight-feature-box">
                                <div className="freight-feature-icon-square">
                                    <i className="fas fa-globe-americas"></i>
                                </div>
                                <div className="freight-feature-content">
                                    <h3 className="freight-feature-title">Global Reach, Local Expertise</h3>
                                    <p className="freight-feature-text">
                                        With strong roots in the UAE, we connect businesses to international markets through seamless air, sea, and land freight services.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Feature 2 */}
                        <div className="col-lg-6">
                            <div className="freight-feature-box">
                                <div className="freight-feature-icon-square">
                                    <i className="fas fa-boxes"></i>
                                </div>
                                <div className="freight-feature-content">
                                    <h3 className="freight-feature-title">Comprehensive Logistics</h3>
                                    <p className="freight-feature-text">
                                        From cargo handling to supply chain management, we provide end-to-end solutions tailored to meet diverse industry needs.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Feature 3 */}
                        <div className="col-lg-6">
                            <div className="freight-feature-box">
                                <div className="freight-feature-icon-square">
                                    <i className="fas fa-clock"></i>
                                </div>
                                <div className="freight-feature-content">
                                    <h3 className="freight-feature-title">Efficiency & Reliability</h3>
                                    <p className="freight-feature-text">
                                        Our commitment to timely deliveries and secure transportation ensures that your goods arrive safely, wherever the destination.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Feature 4 */}
                        <div className="col-lg-6">
                            <div className="freight-feature-box">
                                <div className="freight-feature-icon-square">
                                    <i className="fas fa-handshake"></i>
                                </div>
                                <div className="freight-feature-content">
                                    <h3 className="freight-feature-title">Customer-Centric Approach</h3>
                                    <p className="freight-feature-text">
                                        We pride ourselves on building long-term partnerships by offering personalized service and innovative logistics strategies.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Professional Image Section */}
            <section className="freight-image-section">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-6">
                            <div className="freight-image-content">
                                <div className="freight-section-badge">Our Expertise</div>
                                <h2 className="freight-image-title">30 Years of Excellence in Logistics</h2>
                                <p className="freight-image-description">
                                    With three decades of experience in Dubai's dynamic logistics landscape, we have established ourselves as a trusted partner for businesses worldwide.
                                </p>
                                <div className="freight-stats-row">
                                    <div className="freight-stat-item">
                                        <div className="freight-stat-number">30+</div>
                                        <div className="freight-stat-label">Years Experience</div>
                                    </div>
                                    <div className="freight-stat-item">
                                        <div className="freight-stat-number">1000+</div>
                                        <div className="freight-stat-label">Happy Clients</div>
                                    </div>
                                    <div className="freight-stat-item">
                                        <div className="freight-stat-number">50+</div>
                                        <div className="freight-stat-label">Countries Served</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="freight-image-wrapper">
                                <div className="freight-image-decoration"></div>
                                <img src={require('../assets/images/transport.jpg')} alt="Transportation" className="freight-main-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
